import { gql } from "@apollo/client";

export default gql`
  mutation RemovePositionFromPortfolioByTickerSymbol($tickerSymbol: TickerSymbol!) {
    removePositionFromPortfolioByTickerSymbol(tickerSymbol: $tickerSymbol)
  }
`;
